import React from "react";
import { KgActivityHistoryIcon } from "../../atoms/KgActivityHistoryIcon";
import { KgInspectorDataGrid } from "../KgInspectorDataGrid";
import {
  ARTIFACT_ACTIVITY_EMPTY_HINT,
  ARTIFACT_ACTIVITY_GRID_COLUMNS,
} from "./artifactActivityGrid.config";
import {
  ActivityBlock,
  CountBadge,
  IconSlot,
  SectionHeader,
  SectionTitle,
  SummaryCard,
  SummaryMeta,
  SummaryTitle,
  TabRoot,
} from "./KgInspectorArtifactActivityTab.styles";
import type { KgInspectorArtifactActivityTabProps } from "./KgInspectorArtifactActivityTab.types";

export const KgInspectorArtifactActivityTab: React.FC<
  KgInspectorArtifactActivityTabProps
> = ({ activity }) => {
  const summary = activity?.summary;
  const events = activity?.events ?? [];

  return (
    <TabRoot>
      {summary ? (
        <SummaryCard>
          <SummaryTitle>{summary.title}</SummaryTitle>
          <SummaryMeta>
            {summary.date} • {summary.layoutTemplate}
          </SummaryMeta>
        </SummaryCard>
      ) : null}

      <ActivityBlock>
        <SectionHeader>
          <IconSlot>
            <KgActivityHistoryIcon size={16} />
          </IconSlot>
          <SectionTitle>Activity</SectionTitle>
          {events.length > 0 && <CountBadge>{events.length}</CountBadge>}
        </SectionHeader>

        <KgInspectorDataGrid
          rows={events}
          rowKey={(row) => row.id}
          contentAlign="start"
          columns={ARTIFACT_ACTIVITY_GRID_COLUMNS}
          emptyHint={ARTIFACT_ACTIVITY_EMPTY_HINT}
        />
      </ActivityBlock>
    </TabRoot>
  );
};

export default KgInspectorArtifactActivityTab;
